<template>
  <div class="app-container">
    <el-tabs
      type="border-card"
      @tab-click="handleTabClick"
      v-model="activeName"
      v-tab-change:activeName="setActiveName"
    >
      <el-tab-pane label="系统麦粒统计" name="0">
        <el-row :gutter="20">
          <el-col :span="16">
            <div class="btn-group" style="margin-bottom: 20px">
              <!-- 切换菜单 -->
              <el-button-group>
                <el-button
                  :type="currentTab === '0' ? 'primary' : ''"
                  size="small"
                  @click="switchTab('0')"
                >
                  麦粒发放
                </el-button>
                <el-button
                  :type="currentTab === '1' ? 'primary' : ''"
                  size="small"
                  @click="switchTab('1')"
                >
                  麦粒回收
                </el-button>
                <el-button
                  :type="currentTab === '2' ? 'primary' : ''"
                  size="small"
                  @click="switchTab('2')"
                >
                  麦粒分布
                </el-button>
              </el-button-group>

              <!-- 时间菜单 -->
              <div class="block">
                <el-button-group>
                  <el-button
                    :type="currentDateTab === '0' ? 'primary' : ''"
                    size="small"
                    @click="switchDateTab(0)"
                  >
                    今天
                  </el-button>
                  <el-button
                    :type="currentDateTab === '1' ? 'primary' : ''"
                    size="small"
                    @click="switchDateTab(7)"
                  >
                    一周
                  </el-button>
                  <el-button
                    :type="currentDateTab === '2' ? 'primary' : ''"
                    size="small"
                    style="border-right: 0; border-radius: 0"
                    @click="switchDateTab(30)"
                  >
                    30天
                  </el-button>
                </el-button-group>
                <el-date-picker
                  v-model="daterange"
                  size="small"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="border-radius: 0 3px 3px 0"
                />
              </div>
            </div>
            <div v-show="currentTab === '0'" id="chartLine1-1"></div>
            <div v-show="currentTab === '0'" id="chartLine1-2"></div>
            <div v-show="currentTab === '1'" id="chartLine2-1"></div>
            <div v-show="currentTab === '1'" id="chartLine2-2"></div>
            <div v-show="currentTab === '2'" id="chartPie3-1"></div>
            <div v-show="currentTab === '2'" id="chartPie3-2"></div>
          </el-col>
          <el-col :span="8">
            <div class="table-block">
              <div class="table-title">麦粒排行榜</div>
              <div>
                <el-table :data="tableData" stripe style="width: 100%">
                  <el-table-column
                    prop="Rank"
                    label="排名"
                    width="80"
                    align="center"
                  />
                  <el-table-column
                    prop="UserID"
                    label="ID"
                    width="100"
                    align="center"
                  />
                  <el-table-column
                    prop="Nickname"
                    label="姓名"
                    min-width="100"
                    align="center"
                  />
                  <el-table-column
                    prop="TotalCredits"
                    label="麦粒积分"
                    width="100"
                    align="center"
                  />
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="用户麦粒统计" name="1">
        <div class="topbar">
          <el-input
            v-model="search"
            placeholder="手机号"
            size="small"
            prefix-icon="el-icon-search"
          />
          <el-button
            :loading="exportLoading"
            type="primary"
            icon="el-icon-download"
            size="small"
            @click.stop="handleDownload"
          >
            导出为Excel
          </el-button>
        </div>
        <el-table
          ref="table"
          :data="tableData2"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column
            label="ID"
            prop="UserID"
            width="100px"
            align="center"
          />
          <el-table-column
            label="姓名"
            prop="Nickname"
            min-width="200px"
            align="center"
          />
          <el-table-column
            label="手机号"
            prop="MobilePhone"
            width="200px"
            align="center"
          />
          <el-table-column
            label="地址"
            prop="Address"
            width="200px"
            align="center"
          />
          <el-table-column
            label="公司"
            prop="Organization"
            width="200px"
            align="center"
          />
          <el-table-column
            label="性别"
            prop="Sex"
            width="100px"
            align="center"
          />
          <el-table-column
            label="排名"
            prop="Rank"
            width="100px"
            align="center"
          />
          <el-table-column
            label="经验值"
            prop="TotalExperience"
            width="150px"
            align="center"
          />
          <el-table-column
            label="积分值"
            prop="TotalCredits"
            width="150px"
            align="center"
          />
          <el-table-column
            label="历史总积分"
            prop="HistoryCredits"
            width="150px"
            align="center"
          />
          <el-table-column label="操作" width="150px" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                type=""
                @click.stop="seeMore(scope.$index, scope.row)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          v-show="totalCount > pageSize"
          background
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="currentChange"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  TODAY,
  WITHIN_A_WEEK,
  WITHIN_A_MONTH,
  TOTAL,
  Android,
  iOS,
} from "@/assets/constant";
import dayjs from "dayjs";
import {
  getMAiLiInfoAndRank,
  getMaiLiChangeDetail,
  getCountByMaiLiCredit,
  getMaiLiCountChange,
  getMaiLiCountChangeByModel,
} from "@/api/system/statisticsManagement/maili";
export default {
  data() {
    return {
      exportLoading: false, // 导出excel loading
      activeName: "0",
      currentTab: "0",
      currentDateTab: "0",
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      daterange: "",
      tableData: [],
      tableData2: [],
      search: "",
      chartLine11: "",
      chartLineOption11: {},
      chartLine12: "",
      chartLineOption12: {},
      chartLine21: "",
      chartLineOption21: {},
      chartLine22: "",
      chartLineOption22: {},
      chartPie31: "",
      chartPieOption31: {},
      chartPie32: "",
      chartPieOption32: {},

      // 发放麦粒
      distributeMaiLi: {
        today: 0, // 今天
        week: 0, // 一周内
        thirtyDays: 0, // 三十天内
        total: 0, // 累计
      },
      // 回收麦粒
      recycleMaiLi: {
        today: 0, // 今天
        week: 0, // 一周内
        thirtyDays: 0, // 三十天内
        total: 0, // 累计
      },
    };
  },
  computed: {
    getSidebarStatus() {
      return this.$store.state.app.sidebar.opened;
    },
  },
  watch: {
    getSidebarStatus() {
      setTimeout(() => {
        switch (this.currentTab) {
          case "0":
            this.chartLine11.resize();
            this.chartLine12.resize();
            break;
          case "1":
            this.chartLine21.resize();
            this.chartLine22.resize();
            break;
          case "2":
            this.chartPie31.resize();
            this.chartPie32.resize();
            break;
        }
      }, 300);
    },
  },
  created() {
    this.refreshCurrentList();
  },
  mounted() {
    this.drawLine("0", TODAY);
  },
  methods: {
    /**
     * 导出 excel
     */
    handleDownload() {
      this.exportLoading = true;
      import("@/vendor/Export2Excel.js").then((excel) => {
        const tHeader = [
          "用户名",
          "电话",
          "地址",
          "公司",
          "积分值",
          "历史总积分",
          "排名",
        ];
        const filterVal = [
          "Nickname",
          "MobilePhone",
          "Address",
          "Organization",
          "TotalCredits",
          "HistoryCredits",
          "Rank",
        ];
        const list = this.tableData2;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "用户麦粒值",
          autoWidth: true,
          bookType: "xlsx",
        });
        this.exportLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    handleTabClick() {
      this.currentPage = 1;
      this.refreshCurrentList();
    },
    /**
     * @description: 刷新列表
     * @param {*}
     * @return {*}
     */
    refreshCurrentList() {
      switch (this.activeName) {
        case "0":
          this.getMaiLiRank1();
          break;
        case "1":
          this.getMaiLiRank2();
          break;
      }
    },
    /**
     * @description: 翻页
     * @param {*} currentPage
     * @return {*}
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.refreshCurrentList();
    },
    /**
     * 切换菜单
     */
    switchTab(index) {
      this.currentTab = index;
      const time = TODAY;
      this.currentDateTab = TODAY;

      this.drawLine(index, time);
      this.drawPie(index);
    },
    /**
     * 切换日期
     */
    switchDateTab(index) {
      if (this.currentDateTab === index) return;

      this.currentDateTab = index;
      const time = index;
      this.drawLine(this.currentTab, time);
    },
    /**
     * 生成折线图
     */
    async drawLine(index, time) {
      switch (index) {
        case "0":
          const res = await this.getMaiLiCountChange(time);
          console.log(res);

          // 提取时间
          const timeList1 = res.Add.map((item) => {
            return item.CountDate;
          });
          // 提取数据
          const dataList1 = res.Add.map((item) => {
            return item.Count;
          });

          // 麦粒发放量
          this.chartLine11 = this.$echarts.init(
            document.getElementById("chartLine1-1")
          );
          this.chartLineOption11 = {
            title: {
              text: "发放量",
              x: "center",
              top: "5%",
            },
            tooltip: {
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985",
                },
              },
            },
            grid: {
              top: "15%",
              left: "2%",
              right: "2%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: timeList1,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                data: dataList1,
                type: "line",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#409EFF",
                  },
                },
                label: {
                  show: true,
                  position: "insideBottom",
                  color: "rgba(0, 0, 0, 1)",
                  textStyle: {
                    fontSize: 15,
                  },
                },
              },
            ],
          };
          this.chartLine11.setOption(this.chartLineOption11);

          // 麦粒累计发放量
          // this.chartLine12 = this.$echarts.init(
          //   document.getElementById("chartLine1-2")
          // );
          // this.chartLineOption12 = {
          //   title: {
          //     text: "累计发放量",
          //     x: "center",
          //     top: "5%",
          //   },
          //   tooltip: {
          //     axisPointer: {
          //       type: "cross",
          //       label: {
          //         backgroundColor: "#6a7985",
          //       },
          //     },
          //   },
          //   grid: {
          //     top: "15%",
          //     left: "2%",
          //     right: "2%",
          //     bottom: "5%",
          //     containLabel: true,
          //   },
          //   xAxis: {
          //     type: "category",
          //     boundaryGap: false,
          //     data: timeList2,
          //   },
          //   yAxis: {
          //     type: "value",
          //   },
          //   series: [
          //     {
          //       data: dataList2,
          //       type: "line",
          //       areaStyle: {},
          //       itemStyle: {
          //         normal: {
          //           color: "#409EFF",
          //         },
          //       },
          //       label: {
          //         show: true,
          //         position: "insideBottom",
          //         color: "rgba(0, 0, 0, 1)",
          //         textStyle: {
          //           fontSize: 15,
          //         },
          //       },
          //     },
          //   ],
          // };
          // this.chartLine12.setOption(this.chartLineOption12);
          break;
        case "1":
          const res1 = await this.getMaiLiCountChange(time);

          // 提取时间
          const timeList2 = res1.Recycle.map((item) => {
            return item.CountDate;
          });
          // 提取数据
          const dataList2 = res1.Recycle.map((item) => {
            return item.Count;
          });
          // 麦粒回收量
          this.chartLine21 = this.$echarts.init(
            document.getElementById("chartLine2-1")
          );
          this.chartLineOption21 = {
            title: {
              text: "回收量",
              x: "center",
              top: "5%",
            },
            tooltip: {
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985",
                },
              },
            },
            grid: {
              top: "15%",
              left: "2%",
              right: "2%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: timeList2,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                data: dataList2,
                type: "line",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#409EFF",
                  },
                },
                label: {
                  show: true,
                  position: "insideBottom",
                  color: "rgba(0, 0, 0, 1)",
                  textStyle: {
                    fontSize: 15,
                  },
                },
              },
            ],
          };
          this.chartLine21.setOption(this.chartLineOption21);

          // 麦粒累计回收量
          // this.chartLine22 = this.$echarts.init(
          //   document.getElementById("chartLine2-2")
          // );
          // this.chartLineOption22 = {
          //   title: {
          //     text: "累计回收量",
          //     x: "center",
          //     top: "5%",
          //   },
          //   grid: {
          //     top: "15%",
          //     left: "2%",
          //     right: "2%",
          //     bottom: "5%",
          //     containLabel: true,
          //   },
          //   xAxis: {
          //     type: "category",
          //     boundaryGap: false,
          //     data: timeList4,
          //   },
          //   yAxis: {
          //     type: "value",
          //   },
          //   series: [
          //     {
          //       data: dataList4,
          //       type: "line",
          //       areaStyle: {},
          //       itemStyle: {
          //         normal: {
          //           color: "#409EFF",
          //         },
          //       },
          //       label: {
          //         show: true,
          //         position: "insideBottom",
          //         color: "rgba(0, 0, 0, 1)",
          //         textStyle: {
          //           fontSize: 15,
          //         },
          //       },
          //     },
          //   ],
          // };
          // this.chartLine22.setOption(this.chartLineOption22);
          break;
      }
    },
    /**
     * 生成饼图
     */
    async drawPie(index) {
      if (index === "2") {
        const res1 = await this.getCountByMaiLiCredit();
        console.log(res1);

        // 提取分段区间
        const sectionList = res1.map((item) => {
          if (item.Count !== 0) {
            return item.MaiPart;
          }
        });
        // 提取数据
        const sectionDataList = res1.map((item) => {
          if (item.Count !== 0) {
            return {
              value: item.Count,
              name: item.MaiPart,
            };
          }
        });

        const res2 = await this.getMaiLiCountChangeByModel();
        console.log(res2);
        // 提取模块名
        const moduleNameList = res2.PlusList.map((item) => {
          return item.Model;
        });
        // 提取数据
        const moduleDataList = res2.PlusList.map((item) => {
          return {
            value: item.Count,
            name: item.Model,
          };
        });

        this.chartPie31 = this.$echarts.init(
          document.getElementById("chartPie3-1")
        );
        this.chartPieOption31 = {
          title: {
            text: "各积分段占比",
            left: "center",
            top: "20",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "20",
            top: "20",
            data: sectionList,
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: sectionDataList.sort(function (a, b) {
                return b.value - a.value;
              }),
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        this.chartPie31.setOption(this.chartPieOption31);

        this.chartPie32 = this.$echarts.init(
          document.getElementById("chartPie3-2")
        );
        this.chartPieOption32 = {
          title: {
            text: "各模块积分占比",
            left: "center",
            top: "20",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "20",
            top: "20",
            data: moduleNameList,
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: moduleDataList.sort(function (a, b) {
                return b.value - a.value;
              }),
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        this.chartPie32.setOption(this.chartPieOption32);
      }
    },
    seeMore() {
      alert("See More");
    },
    /**
     * @description: 获取麦粒排行榜
     * @param {*}
     * @return {*}
     */
    getMaiLiRank1() {
      const params = {
        timeType: 0,
        pageNumber: 1,
        pageSize: 15,
      };

      getMAiLiInfoAndRank(params).then((res) => {
        this.tableData = res.Rows;
      });
    },
    getMaiLiRank2() {
      const params = {
        timeType: 0,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };

      getMAiLiInfoAndRank(params).then((res) => {
        this.tableData2 = res.Rows;
        this.totalCount = res.Total;
      });
    },
    /**
     * 获取不统计分段的人数统计
     */
    async getCountByMaiLiCredit() {
      const res = await getCountByMaiLiCredit();

      return res.resultData;
    },
    /**
     * 获取各个模块的积分情况
     */
    async getMaiLiCountChangeByModel() {
      const startTime = "1970/1/1";
      const endTime = dayjs(new Date()).format("YYYY/MM/DD");

      const params = {
        StartTime: startTime,
        EndTime: endTime,
      };

      const res = await getMaiLiCountChangeByModel(params);

      return res.resultData;
    },
    setTime() {
      const myDate = new Date();
      this.date = dayjs(myDate).format("YYYY/MM/DD");
    },
    /**
     * 获取麦粒产生和消耗情况
     */
    async getMaiLiCountChange(time) {
      let params = {};

      if (time !== undefined) {
        this.setTime();
        let EndTime = this.date;
        let StartTime = dayjs(EndTime)
          .subtract(time, "day")
          .format("YYYY/MM/DD");
        params = {
          StartTime,
          EndTime,
        };
      }

      const res = await getMaiLiCountChange(params);
      return res.resultData;
    },
    /**
     * 获取今日麦粒情况
     */
    async getNewUsersInToday() {
      const res = await this.getMaiLiCountChange(TODAY);

      this.distributeMaiLi.today = res.Add;
    },
    /**
     * 获取一周内新增用户
     */
    async getNewUsersInWeek() {
      const res = await this.getMaiLiCountChange(WITHIN_A_WEEK);
      console.log("WITHIN_A_WEEK", res);
      // 获取此时月日
      const date =
        dayjs(new Date()).get("month") +
        1 +
        "/" +
        dayjs(new Date()).get("date");
      // 获取数组中对应数据
      const data = res.find((item) => {
        return date === item.CountDate;
      });
      console.log("data", data);

      this.newUser.week = data.Count;
    },
    /**
     * 获取30天内新增用户
     */
    async getNewUsersInThirtyDays() {
      const res = await this.getMaiLiCountChange(WITHIN_A_MONTH);
      console.log("WITHIN_A_MONTH", res);
      // 获取此时月日
      const date =
        dayjs(new Date()).get("month") +
        1 +
        "/" +
        dayjs(new Date()).get("date");
      // 获取数组中对应数据
      const data = res.find((item) => {
        return date === item.CountDate;
      });

      console.log("data", data);
      this.newUser.thirtyDays = data.Count;
    },
  },
};
</script>

<style scoped lang="scss">
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.block {
  display: flex;
  align-items: center;
}
.table-block {
  display: flex;
  flex-direction: column;
  border: 1px solid #ebeef5;
  border-bottom: none;

  .table-title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    padding: 20px 0;
    font-size: 18px;
    border-bottom: 1px solid #ebeef5;
  }
}

#chartLine1-1,
#chartLine1-2,
#chartLine2-1,
#chartLine2-2 {
  width: 100%;
  height: 390px;
}

#chartPie3-1,
#chartPie3-2 {
  width: 100%;
  height: 390px;
}
</style>
